import React, { useState } from 'react';

const GetInTouch = ({ isCompact = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    tel_no: '',
    message: '',
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // API URL'ini dinamik olarak al
      const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://mayadangayrimenkul.com.tr';
      const apiUrl = `${baseUrl}/api/contactsend`;
      
      console.log('API URL:', apiUrl);
      console.log('Form Data:', formData);
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      console.log('Response status:', response.status);
      console.log('Response:', response);

      if (response.status === 200) {
        setMessage('Görüşme talebiniz gönderildi.');
        setFormData({ name: '', tel_no: '', message: '' });
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('API Hatası:', error);
      setMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  // Ana sayfa için compact versiyon
  if (isCompact) {
    return (
      <div className="bg-gray-800 dark:bg-white border border-gray-700 dark:border-gray-200 rounded-lg p-6">
        <h3 className="text-2xl font-semibold text-gray-200 dark:text-gray-800 mb-6">Görüşme Planlayın</h3>
        <p className="text-gray-300 dark:text-gray-600 mb-6">
          Emlak, gayrimenkul, yatırım konularında danışmanlık için görüşme planlayın
        </p>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 bg-slate-700 dark:bg-white border border-slate-600 dark:border-gray-300 rounded-lg text-slate-200 dark:text-gray-800 placeholder-slate-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#EFBB4C]"
            placeholder="Ad Soyad"
            required
          />
          <input
            type="tel"
            name="tel_no"
            value={formData.tel_no}
            onChange={handleChange}
            className="w-full p-3 bg-slate-700 dark:bg-white border border-slate-600 dark:border-gray-300 rounded-lg text-slate-200 dark:text-gray-800 placeholder-slate-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#EFBB4C]"
            placeholder="Telefon"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-3 bg-slate-700 dark:bg-white border border-slate-600 dark:border-gray-300 rounded-lg text-slate-200 dark:text-gray-800 placeholder-slate-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#EFBB4C] resize-none"
            rows={3}
            placeholder="Görüşme konusu ve mesajınız"
            required
          ></textarea>
          
          {message && (
            <div className={`p-3 rounded-lg ${message.includes('gönderildi') ? 'bg-green-500/20 border border-green-500/50' : 'bg-red-500/20 border border-red-500/50'}`}>
              <p className={message.includes('gönderildi') ? 'text-green-400' : 'text-red-400'}>{message}</p>
            </div>
          )}
          
          <button 
            type="submit" 
            className="w-full bg-[#EFBB4C] hover:bg-[#d4a63f] text-[#252836] font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Görüşme Planla
          </button>
        </form>
      </div>
    );
  }

  // Orijinal tam sayfa versiyon
  return (
    <div className="pt-10 pb-16">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="h-full w-full flex-1 basis-[18rem]">
          <img src="/images/property (39).jpg" alt="" className="w-full h-full" />
        </div>
        <div className="flex-1 basis-[18rem] bg-secondary py-6 !text-slate-200">
          <div className="max-w-[350px] w-full mx-auto bg-[#0a5076] p-3 rounded-lg">
            <h1 className="text-lg font-semibold">Görüşme Planlayın</h1>
            <p>Emlak, gayrimenkul, yatırım konularında danışmanlık için görüşme planlayın</p>
            <div className="mt-4">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-2 py-1 border-none rounded-md outline-none bg-secondary"
                placeholder="Ad Soyad"
              />
              <input
                type="tel"
                name="tel_no"
                value={formData.tel_no}
                onChange={handleChange}
                className="w-full px-2 py-1 mt-3 border-none rounded-md outline-none bg-secondary"
                placeholder="Telefon"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-2 mt-3 border-none rounded-md outline-none bg-secondary"
                rows={3}
                placeholder="Görüşme konusu ve mesajınız"
              ></textarea>
              <button onClick={handleSubmit} className="w-full mt-4 btn btn-primary">
                Görüşme Planla
              </button>
              {message && <div>{message}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
